interface UserProfileActionProps {
  authorId: string
  loggedInUserId: string | undefined
}

const UserProfileActions = ({ authorId, loggedInUserId }: UserProfileActionProps) => {
  return (
    <div className='post__panel-footer--user-action-box'>
      {authorId &&
        loggedInUserId !== authorId &&
          <a className='btn btn-default' href={`/privateMessages/overview#conversation/${authorId}`}>
            Message
          </a>}
    </div>
  )
}

export default UserProfileActions
